import { IAssessmentObject } from "../messages/IAssessments";


export interface IUnitStatistics {
  current_unit: number;
  labs_count: number;
  labs_done: number;
  labs_percentage: number;
  lessons_count: number;
  lessons_done: number;
  lessons_percentage: number;
  unit: number;
}

export interface ISlideVisitedStatistics {
  visited?: number;
}

export interface ILastModuleVisited {
  module_key: string;
  slide_id: string;
  visited_at?: number;
}

export const PRESENTATION = "pres";
export const CODEREVIEW = "coderev";
export const ASSESSMENT = "assess";

export interface IModule {
  id: string;
  title: string;
  type?: string;
  unit?: number;
  // Related to the presentation (type="pres...")
  dir?: string | null;
  presentation?: string;
  disabled?: boolean | null;
  highlight?: boolean | null;
  slides?: { [slideIndex: string]: ISlide } | null;
  labs?: { [labIndex: string]: string } | null;
  // Related to the code review (type="coderev...")
  challenge_id?: string | null; // If multiple challenges exist under a single module, this points to the randomly selected one (otherwise, it is an empty string / null)
  lines?: string[] | null;
  correct?: number | null;
  instructions?: string | null;
  points?: number | null;
}

export interface ISlide {
  id: string;
  notes: string;
  narration: string;
}

export interface IChapter {
  title: string;
  dir: string | null;
  id: string;
  modules: { [moduleIndex: string]: IModule };
  type: string | null; // Default is "pres" (PRESENTATION)
  unit?: number;
  done_count: number | null;
  highlight: boolean | null;
  assessment: string | null;
}

export interface ILmoduleAssessment {
  questions: string;
}


export interface IVMData {
  image_id: string;
  type: string,
  region: string;
  source: string;
  cohort_id: string;
}


export interface IVMs {
  [image_id: string]: IVMData;
}

export interface IContentStructure {
  _json_bucket: string;
  _json_dir: string;
  _json_file: string;
  no_narration?: boolean;
  cohort_id: string;
  cohort_code: string;
  content_cohort_code: string | null;
  dir: string | null;
  group: string;
  id: string;
  lmodule_code: string;
  manual: string;
  manual_path: string | null;
  manual_watermarking: string | null;
  source: string;
  title: string;
  unit: number;
  vms:   IVMs;
  codereview_retry_minutes: number;
  chapters: { [chapterIndex: string]: IChapter } | null;
  next_unit_change?: string;
  enable_lesson_text?: string;
  assessments?: { [key: string]: IAssessmentObject } | null;
}

export interface ICodereviewContentResponse {
  enabled: boolean;
  enabled_text?: string;
  user_id: string;
  csrf_token: string;
  cohort_code: string;
  lmodule_code: string;
  content_id: string;
  chapter_id: string;
  codereview_id: string;
  module?: IModule;
  lab_accomplishment?: LabAccomplishment;
}

export interface IContentData {
  content_root: string;
  content_structure: IContentStructure;
}

export type SlideVisitedStatisticsDict = {
  [slideId: string]: ISlideVisitedStatistics | number;
};

export type VisitedSlides = {
  [contentKey: string]: {
    [moduleKey: string]: ILastModuleVisited | SlideVisitedStatisticsDict;
  };
};

export type LabAccomplishment = {
  finished: boolean;
  can_retry: boolean;
  started: number;
  status: string;
  line_marked?: number;
  points?: number;
  codereview_retry_minutes: number;
}

export type LabAccomplishments = {
  [labId: string]: {
    [started: number]: LabAccomplishment
  };
};

export interface IGetUserContentResponse {
  last_content_visited: string;
  content_data: IContentData[];
  statistics: { [unit: number]: IUnitStatistics };
  visitedslides: VisitedSlides;
  lab_accomplishments: LabAccomplishments;
}
